module.exports = __webpack_public_path__ + "img/push.457eb316.png";